import React from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import { getRespondent, submitGMA } from 'ducks/respondent'
import { WaveContainer } from 'components/quiz/WaveContainer/WaveContainer'
import AbilityQuestion from './AbilityQuestion/AbilityQuestion'
import AbilityBar from './AbilityBar/AbilityBar'
import AbilityResults from './AbilityResults/AbilityResults'
import ConfirmFinish from './ConfirmFinish/ConfirmFinish'
import { t } from 'ttag'
import styles from '../../personality/PersonalityQuestionPage/PersonalityQuestionPage.module.scss'

const AbilityQuestionPage = ({ gma, status, name, loading, submitGMA }) => {
  if (loading) {
    return null
  }

  if (!status && !name) {
    return (
      <WaveContainer rollUp>
        <div className={styles.noUserContainer}>
          <div className={styles.noUserMessage}>
            <div>{t`Current respondent does not exist`}.</div>
            <div className={styles.contactMessage}>
              {t`Please email us at post@ebber.com if you can't find what you're looking for`}
              .
            </div>
          </div>
        </div>
      </WaveContainer>
    )
  }

  if (gma.status === 'fetching') {
    return null
  }

  if (gma.status === 'completed') {
    return (
      <WaveContainer rollUp>
        <AbilityResults />
      </WaveContainer>
    )
  }

  return (
    <WaveContainer
      showFinishButton
      finishButtonLabel={t`Finish`}
      handleExit={submitGMA}
      rollUp
    >
      {gma.status === 'confirmsubmit' && <ConfirmFinish />}
      <AbilityQuestion />
      <AbilityBar />
    </WaveContainer>
  )
}

export default connect(
  getRespondent,
  { submitGMA },
)(AbilityQuestionPage)
